import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Radio, Button, Row, Col, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;

const DiameterWallThicknessComponent = ({ 
    data_List, 
    formData, 
    handleInputChange, 
    handleUnitsChange, 
    getCategoryUnitsValue1,
    isEdit = false
}) => {
    const [rows, setRows] = useState([]);

    // Initialize rows from formData
    useEffect(() => {
        if (formData.diameterRows && formData.diameterRows.length > 0) {
            setRows(formData.diameterRows);
        } else {
            setRows([{ id: 1, diameter: '', wt1: '', wt2: '', wt3: '', wt4: '' }]);
        }
    }, [formData.diameterRows]);

    const addRow = () => {
        const newId = Math.max(...rows.map(row => row.id), 0) + 1;
        const newRow = { id: newId, diameter: '', wt1: '', wt2: '', wt3: '', wt4: '' };
        const updatedRows = [...rows, newRow];
        setRows(updatedRows);
        
        // Update the main form data
        handleInputChange('diameterRows', updatedRows);
        
        // Initialize units for the new row
        const currentUnits = formData.Units?.diameterRows || [];
        const newUnits = [...currentUnits, {
            id: newId,
            wt1: 'mm',
            wt2: 'mm',
            wt3: 'mm',
            wt4: 'mm'
        }];
        handleUnitsChange('diameterRows', newUnits);
    };

    const removeRow = (id) => {
        if (rows.length > 1) {
            const updatedRows = rows.filter(row => row.id !== id);
            setRows(updatedRows);
            
            // Update the main form data
            handleInputChange('diameterRows', updatedRows);
            
            // Remove units for the deleted row
            const currentUnits = formData.Units?.diameterRows || [];
            const updatedUnits = currentUnits.filter(unit => unit.id !== id);
            handleUnitsChange('diameterRows', updatedUnits);
        }
    };

    const updateRowData = (rowId, field, value) => {
        const updatedRows = rows.map(row => 
            row.id === rowId ? { ...row, [field]: value } : row
        );
        setRows(updatedRows);
        
        // Update the main form data
        handleInputChange('diameterRows', updatedRows);
    };

    const updateRowUnits = (rowId, field, value) => {
        const currentUnits = formData.Units?.diameterRows || [];
        const updatedUnits = currentUnits.map(unit => 
            unit.id === rowId ? { ...unit, [field]: value } : unit
        );
        handleUnitsChange('diameterRows', updatedUnits);
    };

    const getRowUnitsValue = (rowId, field) => {
        const currentUnits = formData.Units?.diameterRows || [];
        const unit = currentUnits.find(u => u.id === rowId);
        return unit ? unit[field] : 'mm';
    };

    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '16px' }}>
                <Col lg={4}>
                    <div style={{ 
                        fontWeight: 'bold', 
                        fontSize: '14px',
                        marginBottom: '8px'
                    }}>
                        Diameter
                    </div>
                </Col>
                <Col lg={4}>
                    <div style={{ 
                        fontWeight: 'bold', 
                        fontSize: '14px',
                        marginBottom: '8px'
                    }}>
                        Wall Thickness 1
                    </div>
                </Col>
                <Col lg={4}>
                    <div style={{ 
                        fontWeight: 'bold', 
                        fontSize: '14px',
                        marginBottom: '8px'
                    }}>
                        Wall Thickness 2
                    </div>
                </Col>
                <Col lg={4}>
                    <div style={{ 
                        fontWeight: 'bold', 
                        fontSize: '14px',
                        marginBottom: '8px'
                    }}>
                        Wall Thickness 3
                    </div>
                </Col>
                <Col lg={4}>
                    <div style={{ 
                        fontWeight: 'bold', 
                        fontSize: '14px',
                        marginBottom: '8px'
                    }}>
                        Wall Thickness 4
                    </div>
                </Col>
                {!isEdit && (
                    <Col lg={4}>
                        <div style={{ 
                            fontWeight: 'bold', 
                            fontSize: '14px',
                            marginBottom: '8px'
                        }}>
                            Actions
                        </div>
                    </Col>
                )}
            </Row>
            
            {rows.map((row, index) => (
                <Row gutter={24} key={row.id} style={{ marginBottom: '16px' }}>
                    <Col lg={4}>
                        <Form.Item 
                            name={`diameter_${row.id}`}
                        >
                            <Select 
                                className='maintenance-select' 
                                placeholder={'Select Category'} 
                                size="large" 
                                style={{ marginTop: '-5px' }}
                                showSearch 
                                onChange={(value) => updateRowData(row.id, 'diameter', value)}
                                allowClear
                                value={row.diameter}
                            >
                                {data_List.diameters &&
                                    data_List.diameters.map((item, i) => (
                                        <Option key={i} value={item.diameter}>
                                            {item.diameter}
                                        </Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    
                    <Col lg={4}>
                        <Form.Item name={`wt1_${row.id}`}>
                            <div style={{
                                border: '1px solid #d9d9d9',
                                padding: '5px',
                                paddingLeft:'2px',
                                borderRadius: '5px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <Input 
                                    style={{ flex: '0 0 45%' }}
                                    value={row.wt1}
                                    onChange={(e) => updateRowData(row.id, 'wt1', e.target.value)}
                                    size="large"
                                    type='number' 
                                />
                                <div className='report-radio' style={{ flex: '0 0 40%', paddingLeft: '3px' }}>
                                    <Radio.Group 
                                        style={{ display: "flex", marginRight:'0px', padding:'0px' }}
                                        value={getRowUnitsValue(row.id, 'wt1')}
                                        onChange={(e) => updateRowUnits(row.id, 'wt1', e.target.value)}
                                    >
                                        <Radio value={'mm'} style={{ marginRight:'2px', padding:'0px' }}>mm</Radio>
                                        <Radio value={'inch'}>inch</Radio>
                                    </Radio.Group>
                                </div>
                            </div>
                        </Form.Item>
                    </Col>
                    
                    <Col lg={4}>
                        <Form.Item name={`wt2_${row.id}`}>
                            <div style={{
                                border: '1px solid #d9d9d9',
                                padding: '5px',
                                paddingLeft:'2px',
                                borderRadius: '5px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <Input 
                                    style={{ flex: '0 0 45%' }}
                                    value={row.wt2}
                                    onChange={(e) => updateRowData(row.id, 'wt2', e.target.value)}
                                    size="large"
                                    type='number' 
                                />
                                <div className='report-radio' style={{ flex: '0 0 40%', paddingLeft: '3px' }}>
                                    <Radio.Group 
                                        style={{ display: "flex", marginRight:'0px' }}
                                        value={getRowUnitsValue(row.id, 'wt2')}
                                        onChange={(e) => updateRowUnits(row.id, 'wt2', e.target.value)}
                                    >
                                        <Radio value={'mm'} style={{ marginRight:'2px' }}>mm</Radio>
                                        <Radio value={'inch'} >inch</Radio>
                                    </Radio.Group>
                                </div>
                            </div>
                        </Form.Item>
                    </Col>
                    
                    <Col lg={4}>
                        <Form.Item name={`wt3_${row.id}`}>
                            <div style={{
                                border: '1px solid #d9d9d9',
                                padding: '5px',
                                paddingLeft:'2px',
                                borderRadius: '5px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <Input 
                                    style={{ flex: '0 0 45%' }}
                                    value={row.wt3}
                                    onChange={(e) => updateRowData(row.id, 'wt3', e.target.value)}
                                    size="large"
                                    type='number' 
                                />
                                <div className='report-radio' style={{ flex: '0 0 40%', paddingLeft: '3px' }}>
                                    <Radio.Group 
                                        style={{ display: "flex", marginRight:'0px' }}
                                        value={getRowUnitsValue(row.id, 'wt3')}
                                        onChange={(e) => updateRowUnits(row.id, 'wt3', e.target.value)}
                                    >
                                        <Radio value={'mm'} style={{marginRight:'2px'}}>mm</Radio>
                                        <Radio value={'inch'}>inch</Radio>
                                    </Radio.Group>
                                </div>
                            </div>
                        </Form.Item>
                    </Col>
                    
                    <Col lg={4}>
                        <Form.Item name={`wt4_${row.id}`}>
                            <div style={{
                                border: '1px solid #d9d9d9',
                                padding: '5px',
                                paddingLeft:'2px',
                                borderRadius: '5px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <Input 
                                    style={{ flex: '0 0 45%' }}
                                    value={row.wt4}
                                    onChange={(e) => updateRowData(row.id, 'wt4', e.target.value)}
                                    size="large"
                                    type='number' 
                                />
                                <div className='report-radio' style={{ flex: '0 0 40%', paddingLeft: '3px' }}>
                                    <Radio.Group 
                                        style={{ display: "flex", marginRight:'0px' }}
                                        value={getRowUnitsValue(row.id, 'wt4')}
                                        onChange={(e) => updateRowUnits(row.id, 'wt4', e.target.value)}
                                    >
                                        <Radio value={'mm'} style={{marginRight:'2px'}}>mm</Radio>
                                        <Radio value={'inch'}>inch</Radio>
                                    </Radio.Group>
                                </div>
                            </div>
                        </Form.Item>
                    </Col>
                    
                    {!isEdit && (
                        <Col lg={4} style={{ display: 'flex', alignItems: 'center', paddingBottom: '24px' }}>
                            <Space>
                                {rows.length > 1 && (
                                    <Button 
                                        type="default" 
                                        icon={<DeleteOutlined />} 
                                        onClick={() => removeRow(row.id)}
                                        size="small"
                                        danger
                                    >
                                        
                                    </Button>
                                )}
                                {index === rows.length - 1 && (
                                    <Button 
                                        type="primary" 
                                        icon={<PlusOutlined />} 
                                        onClick={addRow}
                                        size="small"
                                    >
                                    </Button>
                                )}
                            </Space>
                        </Col>
                    )}
                </Row>
            ))}
        </div>
    );
};

export default DiameterWallThicknessComponent; 